import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/home';

interface LatestUpdatesProps {
  comics: ComicItem[];
}

export default function LatestUpdates({ comics }: LatestUpdatesProps) {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">热门漫画每日更新，追更不等待</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            更多更新 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/80 transition-all duration-200"
            >
              <div className="w-16 h-20 md:w-18 md:h-24 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={`${comic.title} - 韩漫最新更新`}
                  title={`${comic.title} - 韩漫最新更新`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{comic.author}</p>
                <div className="mt-2 flex items-center gap-2">
                  <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
                    {comic.latestChapter}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{comic.updateTime}</span>
                </div>
                <div className="mt-1.5 flex items-center gap-1 flex-wrap">
                  {comic.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="px-1.5 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/action"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            更多更新 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}